import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import classes from "./VideoViewer.scss";
import VideoPlayer from "UIComponents/VideoPlayer";
import I18nHOC from "UIComponents/I18nHOC";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { DownloadOutlined, CloseOutlined } from "@toddle-edu/ds-icons";
import { compose } from "lib/apolloClient";
import { downloadFileFromUrl } from "Utils";
import moment from "moment";

class VideoViewer extends React.PureComponent {
  onCloseClick = e => {
    e.stopPropagation();
    if (this.props.closeVideoViewer) {
      this.props.closeVideoViewer();
    }
  };

  onDownloadClick = () => {
    const { fileUrl, name, fileExtension } = this.props;
    if (!_.isNil(fileUrl) && !_.isEmpty(fileUrl)) {
      const timestamp = moment().format("DD-MM-YY_h_mm");
      const filename = "toddle_video_"
        .concat(timestamp)
        .concat("." + fileExtension);
      downloadFileFromUrl({
        name: filename,
        url: fileUrl,
      });
    }
  };
  render() {
    const { videoUrl, isHLSUrl, autoPlay, showDownloadButton, t } = this.props;
    return (
      <div className={classes.container} onClick={this.onCloseClick}>
        <div className={classes.topPanel}>
          <div className={classes.crossSvg} onClick={e => this.onCloseClick(e)}>
            <CloseOutlined
              size="xx-small"
              variant="on"
              className={classes.closeIcon}
            />
          </div>
        </div>
        <div
          className={classes.videoViwerContainer}
          onClick={e => e.stopPropagation()}
        >
          <VideoPlayer
            videoUrl={videoUrl}
            isHLSUrl={isHLSUrl}
            getPlayerRef={ref => (this.videoPlayer = ref)}
            autoPlay={autoPlay}
          />
          {showDownloadButton && (
            <Tooltip tooltip={t("common:download")} placement="top">
              <IconButton
                style={{ marginTop: "16px", alignSelf: "center" }}
                variant={"inline"}
                icon={<DownloadOutlined variant="on" />}
                onClick={this.onDownloadClick}
              />
            </Tooltip>
          )}
        </div>
      </div>
    );
  }
}

export default compose(I18nHOC({ resource: ["common"] }))(VideoViewer);

VideoViewer.defaultProps = {
  isHLSUrl: false,
  autoPlay: false,
  showDownloadButton: false,
};

VideoViewer.propTypes = {
  closeVideoViewer: PropTypes.func,
  videoUrl: PropTypes.string,
  isHLSUrl: PropTypes.bool,
  autoPlay: PropTypes.bool,
  showDownloadButton: PropTypes.bool,
};
